import baseApi from "./base.api"

export type MediaFileResponseType = {
  id: string
  vinculoId?: string | null
  tipoEntidade?: 'Questao' | 'Midia' | 'Personalizacao' | null
  status?: 'Pendente' | 'Concluido' | null
  ordem: number
  link: string
}

export type MediaFileType = {
  id: string
  linkId?: string | null
  entityType?: 'Questao' | 'Midia' | 'Personalizacao' | null
  status?: 'Pendente' | 'Concluido' | null
  order: number
  link: string
}

export type ImageDisplayType = {
  url: string
  isLegacy: boolean
  id?: string
  index?: number
}

const normalizeLocal = (obj: MediaFileResponseType): MediaFileType => ({
  id: obj.id,
  linkId: obj.vinculoId ?? null,
  entityType: obj.tipoEntidade ?? null,
  status: obj.status ?? null,
  order: obj.ordem,
  link: obj.link,
})

export const mediaFileService = {
  ...baseApi,
  resource: 'midiaArquivo',

  get: (opt?: { id?: string, ativo?: boolean, midiaId?: string, page?: number, size?: number }) => {
    return baseApi.get<MediaFileResponseType[]>(`${mediaFileService.resource}`, opt)
      .then(res => ({
        ...res,
        data: res.data.map(el => normalizeLocal(el)),
      }))
      .catch(error => {
        throw error
      })
  },

  saveCarousel: (mediaId: string, { file, order } : { file: File, order?: number }) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('ordem', order?.toString() || '0')

    return baseApi.post<MediaFileResponseType>(`${mediaFileService.resource}/${mediaId}/Carrossel`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(res => normalizeLocal(res.data))
      .catch(error => {
        throw error
      })
  },

  /**
   * Faz o upload de uma imagem para ser vinculada a uma Questão.
   * Deve ser chamado ANTES de salvar a avaliação.
   * Retorna um `MediaFileType` normalizado pronto para ser inserido em `questao.imagens[]`.
   *
   * @param file  - Arquivo de imagem selecionado pelo usuário
   * @param ordem - Posição da imagem na lista (0-based)
   */
  saveQuestaoImagem: ({ file, ordem }: { file: File; ordem: number }) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('ordem', ordem.toString())
    formData.append('status', 'Pendente')
    formData.append('tipoEntidade', 'Questao')
    // vinculoId não é enviado para questão ainda não salva

    return baseApi.post<MediaFileResponseType>(`${mediaFileService.resource}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(res => normalizeLocal(res.data))
      .catch(error => {
        throw error
      })
  },

  delete: ({ id } : { id: string }) => {
    return baseApi.delete(`${mediaFileService.resource}/${id}`)
  },

  deleteMany: (ids: string[]) => {
    return ids.map(id => mediaFileService.delete({ id }))
  },

  order: (items : { id: string, order: number }[]) => {
    return baseApi.post<{ id: string, order: number }[]>(`${mediaFileService.resource}/order`,
      items?.map(item => ({
        id: item.id,
        ordem: item.order
      }))
    )
  },

  save: ({ file, order } : { file: File, order?: number }) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('ordem', order?.toString() || '0')

    return baseApi.post<MediaFileResponseType>(`${mediaFileService.resource}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then(res => normalizeLocal(res.data))
      .catch(error => {
        throw error
      })
  },
}